// removed by extract-text-webpack-plugin
module.exports = {"section":"FormSection__section___jxPt6","section-right":"FormSection__section-right___2ygf7 FormSection__section___jxPt6","dirty":"FormSection__dirty___1TXBC","highlighted":"FormSection__highlighted___1TQLH","dark":"FormSection__dark___1P9uQ"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Form/FormSection.scss
// module id = 539
// module chunks = 0